import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

import AuthGuard from "../utils/auth.guard"; 
import { UserRole } from "../utils/auth.roles";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/sign-in",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        meta: { loginRequired: true},
        component: () => import("@/views/dashboard/Dashboard_OVI.vue"), 
        children: [
          {
            path: "",
            redirect: "reminderspage"
          },
          {
            path: "reminderspage",
            name: "dashboard-welcomepage",
            component: () => import("@/views/ECP_RemindersPage.vue")
          },
          {
            path: "accountinfo",
            name: "dashboard-accountinfo",
            component: () => import("@/views/ECP_AccountInfo.vue")
          },
          {
            path: "recentactivity",
            name: "dashboard-recentactivity",
            component: () => import("@/views/RecentActivity.vue")
          },
          {
            path: "globalpartners",
            name: "dashboard-globalpartners",
            component: () => import("@/views/GlobalPartners.vue")
          },
          {
            path: "primemonitoring",
            name: "dashboard-primemonitoring",
            component: () => import("@/views/ECP_PrimeMonitoring.vue")
          },
          {
            path: "mycoverage",
            name: "dashboard-mycoverage",
            component: () => import("@/views/OVICoverageInfo.vue")
          },
          {
            path: "coveragelist",
            name: "dashboard-coveragelist",
            component: () => import("@/views/OVICoverageTransfer.vue")
          },
          {
            path: "packagepointslist",
            name: "dashboard-packagepointslist",
            component: () => import("@/views/PackagePoints.vue")
          },
          {
            path: "dreamlyf",
            name: "dashboard-dreamlyf",
            component: () => import("@/views/DreamLyf.vue")
          },
          {
            path: "myprospects",
            name: "dashboard-myprospects",
            component: () => import("@/views/MyProspects.vue")
          }
        ]

      },
      {
        path: "/dashboardecp",
        name: "dashboardecp",
        component: () => import("@/views/dashboard/Dashboard_ECP.vue"),
        children: [
          {
            path: "",
            redirect: "reminderspage"
          },
          {
            path: "reminderspage",
            name: "dashboardecp-welcomepage",
            component: () => import("@/views/ECP_RemindersPage.vue")
          },
          {
            path: "primemonitoring",
            name: "dashboarddecp-primemonitoring",
            component: () => import("@/views/ECP_PrimeMonitoring.vue")
          },
          {
            path: "accountinfo",
            name: "dashboard-ecpaccountinfo",
            component: () => import("@/views/ECP_AccountInfo.vue")
          },
          {
            path: "recentactivity",
            name: "dashboardecp-recentactivity",
            component: () => import("@/views/RecentActivity.vue")
          },
          {
            path: "globalpartners",
            name: "dashboardecp-globalpartners",
            component: () => import("@/views/GlobalPartners.vue")
          },
          {
            path: "packagepointslistecp",
            name: "dashboardecp-packagepointslist",
            component: () => import("@/views/PackagePoints.vue")
          },
          {
            path: "pgiecp",
            name: "dashboardecp-pgiecp",
            component: () => import("@/views/PGI.vue")
          }
          ,
          {
            path: "pgiecptop20",
            name: "dashboardecp-pgiecptop20",
            component: () => import("@/views/PGITop20.vue")
          },
          {
            path: "nonga",
            name: "dashboardecp-nonga",
            component: () => import("@/views/NonGA.vue")
          }

        ]
      },
      {
        path: "/dashboardbibo",
        name: "dashboardbibo",
        component: () => import("@/views/dashboard/Dashboard_BIBO.vue")
      },
      {
        path: "/dashboardecc",
        name: "dashboardecc",
        component: () => import("@/views/dashboard/Dashboard_ECC.vue")
      },
      {
        path: "/dashboardpcp",
        name: "dashboardpcp",
        component: () => import("@/views/dashboard/Dashboard_PCP.vue")
      },
      {
        path: "/leaderboard",
        name: "leaderboard",
        meta: { loginRequired: true },
        component: () => import("@/views/Leaderboard.vue"),
        redirect: "top-earner",
        children: [
          {
            path: "top-earner",
            name: "leaderboard-top-earner",
            meta: { metric: "totalIncome" },
            component: () => import("@/views/LeaderboardTab.vue")
          },
          {
            path: "top-consumer",
            name: "leaderboard-top-consumer",
            meta: { metric: "reorderpurchase" },
            component: () => import("@/views/LeaderboardTab.vue")
          },
          {
            path: "top-directs",
            name: "leaderboard-top-directs",
            meta: { metric: "newdirects" },
            component: () => import("@/views/LeaderboardTab.vue")
          }
        ]
      },
      
     /* {
        path: "/vantest",
        name: "vantest",
        meta: { loginRequired: true},
        component: () => import("@/views/VANTESTING.vue")
      }, */
      {
        path: "/builder",
        name: "builder",
        component: () => import("@/views/Builder.vue")
      },
      {
        path: "/transactions",
        name: "transactions",
        meta: { loginRequired: true},
        component: () => import("@/views/Transactions.vue")
      },
      {
        path: "/ai247",
        name: "ai247",
        meta: { loginRequired: true},
        component: () => import("@/views/Ai247.vue")
      },
      {
        path: "/autopma",
        name: "autopma",
        meta: { loginRequired: true},
        component: () => import("@/views/AutoPMA.vue")
      },
      // {
      //   path: "/ustripmonitoring",
      //   name: "ustripmonitoring",
      //   meta: { loginRequired: true},
      //   component: () => import("@/views/USTripMonitoring.vue")
      // },
      {
        path: "/recruitments",
        name: "recruitments",
        meta: { loginRequired: true},
        component: () => import("@/views/Recruitments.vue")
      },
      {
        path: "/override",
        name: "override",
        meta: { loginRequired: true},
        component: () => import("@/views/Override.vue")
      },
      {
        path: "/directsponsored",
        name: "directsponsored",
        meta: { loginRequired: true},
        component: () => import("@/views/DirectSponsored.vue")
      },
      {
        path: "/encashment",
        name: "encashment",
        meta: { loginRequired: true},
        component: () => import("@/views/Encashment.vue")
      },
      {
        path: "/reorder",
        name: "reorder",
        meta: { loginRequired: true},
        component: () => import("@/views/Reorder.vue")
      },
      {
        path: "/stairstep",
        name: "stairstep",
        meta: { loginRequired: true},
        component: () => import("@/views/Stairstep.vue")
      },
      {
        path: "/unilevel",
        name: "unilevel",
        meta: { loginRequired: true},
        component: () => import("@/views/Unilevel.vue")
      },
      {
        path: "/myrebates",
        name: "myrebates",
        meta: { loginRequired: true},
        component: () => import("@/views/MyRebates.vue")
      },
      {
        path: "/productgc",
        name: "productgc",
        meta: { loginRequired: true},
        component: () => import("@/views/ProductGC.vue")
      },

      {
        path: "/biboactivations",
        name: "biboactivations",
        meta: { loginRequired: true},
        component: () => import("@/views/BiboActivation.vue")
      },
      
      
      {
        path: "/upp",
        name: "upp",
        meta: { loginRequired: true},
        component: () => import("@/views/UPP.vue")
      }, 
      {
        path: "/bibo",
        name: "bibo",
        meta: { loginRequired: true},
        component: () => import("@/views/BIBO.vue")
      },
      {
        path: "/biboendorsers",
        name: "biboendorsers",
        meta: { loginRequired: true},
        component: () => import("@/views/BIBO_ENDORSERS.vue")
      },
      {
        path: "/pcp_retailers",
        name: "pcp_retailers",
        meta: { loginRequired: true},
        component: () => import("@/views/PCP_RETAILERS.vue")
      },

      

      // {
      //   path: "/aefc",
      //   name: "aefc",
      //   meta: { loginRequired: true},
      //   component: () => import("@/views/AEFC.vue")
      // },
      {
        path: "/settings/profile",
        name: "profile2 ",
        meta: { loginRequired: true},
        component: () => import("@/views/Profile.vue")
      },
      {
        path: "/settings/team-materials",
        name: "team-materials",
        meta: { loginRequired: true},
        component: () => import("@/views/TeamMaterials.vue")
      },
      {
        path: "/settings/knowledge-bases",
        redirect: { path: "/settings/ai247-portal", query: { tab: "knowledge-bases" } }
      },
      {
        path: "/settings/ai-agents",
        redirect: { path: "/settings/ai247-portal", query: { tab: "ai-agents" } }
      },
      {
        path: "/settings/ai247-portal",
        name: "ai247-portal",
        meta: { loginRequired: true},
        component: () => import("@/views/GhlSubaccount.vue")
      },
      {
        path: "/sites",
        name: "sites",
        meta: { loginRequired: true },
        beforeEnter() {
          const { isSitesBuilderPreviewUser } = require("@/utils/sitesBuilderPreview");
          if (!isSitesBuilderPreviewUser()) {
            return { path: "/dashboard/reminderspage" };
          }
        },
        component: () => import("@/views/sites/SitesList.vue")
      },
      {
        path: "/settings/ghl-subaccount",
        redirect: (to) => ({ path: "/settings/ai247-portal", query: to.query })
      },
      {
        path: "/settings/social-fanout",
        redirect: { path: "/settings/ai247-portal", query: { tab: "social" } }
      },
      {
        path: "/settings/team-content-publish",
        redirect: (to) => ({
          path: "/settings/ai247-portal",
          query: { ...to.query, tab: "publish" }
        })
      },
      {
        path: "/settings/content-publish-history",
        redirect: { path: "/settings/ai247-portal", query: { tab: "history" } }
      },
      {
        path: "/networkmenu/networksales/",
        name: "networksales",
        meta: { loginRequired: true},
        component: () => import("@/views/Networksales.vue")
      },
      {
        path: "/networkmenu/genealogy/",
        name: "networgenealogy",
        meta: { loginRequired: true},
        component: () => import("@/views/network/Genealogy.vue")
      },
      {
        path: "/networkmenu/ppssetup/",
        name: "networkppssetup",
        meta: { loginRequired: true},
        component: () => import("@/views/network/PPSSetup.vue")
      },
      {
        path: "/estore",
        name: "estore",
        meta: { loginRequired: true},
        component: () => import("@/views/Estore.vue")
      },
      {
        path: "/retropma",
        name: "retropma",
        meta: { loginRequired: true},
        component: () => import("@/views/RetroPMA.vue")
      },
      {
        path: "/transferproduct",
        name: "transferproduct",
        meta: { loginRequired: true},
        component: () => import("@/views/TransferProduct.vue")
      },

   /*   {
        path: "/votemsiglow",
        name: "votemsiglow",
        meta: { loginRequired: true},
        component: () => import("@/views/VoteMsIGlow.vue")
      },
*/

      
      {
        path: "/estoretrans",
        name: "estoretrans",
        meta: { loginRequired: true},
        component: () => import("@/views/EstoreTrans.vue")
      },
      {
        path: "/eccorderclaim",
        name: "eccorderclaim",
        meta: { loginRequired: true},
        component: () => import("@/views/Estore_ECCOrderClaim.vue")
      },

      {
        path: "/onlineshop/shopcodes/",
        name: "shopcodes",
        meta: { loginRequired: true},
        component: () => import("@/views/onlineshop/ShopCodes.vue")
      },

      {
        path: "/onlineshop/shopproducts/",
        name: "shopproducts",
        meta: { loginRequired: true},
        component: () => import("@/views/onlineshop/ShopProducts.vue")
      },

      {
        path: "/onlineshop/shoppurchases/",
        name: "shoppurchases",
        meta: { loginRequired: true},
        component: () => import("@/views/onlineshop/ShopPurchases.vue")
      },
      {
        path: "/onlineshop/retailsales/",
        name: "retailsales",
        meta: { loginRequired: true},
        component: () => import("@/views/onlineshop/ShopRetailSales.vue")
      },
      {
        path: "/onlineshop/ecwallet/",
        name: "ecwallet",
        meta: { loginRequired: true},
        component: () => import("@/views/onlineshop/ECWallet.vue")
      },
      {
        path: "/mgpay",
        name: "mgpay",
        meta: { loginRequired: true},
        component: () => import("@/views/onlineshop/MatchinPay.vue")
      },
      {
        path: "/mgpayscan",
        name: "mgpayscan",
        meta: { loginRequired: true},
        component: () => import("@/components/matchinpay/MatchinPayScanQR.vue")
      },
      {
        path: "/mgpaypaymentpage",
        name: "mgpaypaymentpage",
        meta: { loginRequired: true},
        props: true,
        component: () => import("@/components/matchinpay/MatchinPayPaymentPage.vue")
      },
      {
        path: "/mgpaygenerateqr",
        name: "mgpaygenerateqr",
        props: true,
        meta: { loginRequired: true},
        component: () => import("@/components/matchinpay/MatchinPayGenerateQR.vue")
      },

      {
        path: "/hoodiejacket",
        name: "hoodiejacket",
        props: true,
        meta: { loginRequired: true},
        component: () => import("@/views/HoodieJacket.vue")
      },


































      {
        path: "/crafted/pages/profile",
        name: "profile",
        component: () => import("@/views/pages/Profile.vue"),
        children: [
          {
            path: "overview",
            name: "profile-overview",
            component: () => import("@/views/pages/profile/Overview.vue")
          },
          {
            path: "projects",
            name: "profile-projects",
            component: () => import("@/views/pages/profile/Projects.vue")
          },
          {
            path: "campaigns",
            name: "profile-campaigns",
            component: () => import("@/views/pages/profile/Campaigns.vue")
          },
          {
            path: "documents",
            name: "profile-documents",
            component: () => import("@/views/pages/profile/Documents.vue")
          },
          {
            path: "connections",
            name: "profile-connections",
            component: () => import("@/views/pages/profile/Connections.vue")
          },
          {
            path: "activity",
            name: "profile-activity",
            component: () => import("@/views/pages/profile/Activity.vue")
          }
        ]
      },
      {
        path: "/crafted/pages/wizards/horizontal",
        name: "horizontal-wizard",
        component: () => import("@/views/pages/wizards/Horizontal.vue")
      },
      {
        path: "/crafted/pages/wizards/vertical",
        name: "vertical-wizard",
        component: () => import("@/views/pages/wizards/Vertical.vue")
      },
      {
        path: "/crafted/account",
        name: "account",
        component: () => import("@/views/account/Account.vue"),
        children: [
          {
            path: "overview",
            name: "account-overview",
            component: () => import("@/views/account/Overview.vue")
          },
          {
            path: "settings",
            name: "account-settings",
            component: () => import("@/views/account/Settings.vue")
          }
        ]
      },
      {
        path: "/apps/chat/private-chat",
        name: "apps-private-chat",
        component: () => import("@/views/chat/Chat.vue")
      },
      {
        path: "/apps/chat/group-chat",
        name: "apps-group-chat",
        component: () => import("@/views/chat/Chat.vue")
      },
      {
        path: "/apps/chat/drawer-chat",
        name: "apps-drawer-chat",
        component: () => import("@/views/chat/DrawerChat.vue")
      },
      {
        path: "/crafted/modals/general/invite-friends",
        name: "modals-general-invite-friends",
        component: () => import("@/views/modals/general/InviteFriends.vue")
      },
      {
        path: "/crafted/modals/general/view-user",
        name: "modals-general-view-user",
        component: () => import("@/views/modals/general/ViewUsers.vue")
      },
      {
        path: "/crafted/modals/general/upgrade-plan",
        name: "modals-general-upgrade-plan",
        component: () => import("@/views/modals/general/UpgradePlan.vue")
      },
      {
        path: "/crafted/modals/general/share-and-earn",
        name: "modals-general-share-and-earn",
        component: () => import("@/views/modals/general/ShareAndEarn.vue")
      },
      {
        path: "/crafted/modals/forms/new-target",
        name: "modals-forms-new-target",
        component: () => import("@/views/modals/forms/NewTarget.vue")
      },
      {
        path: "/crafted/modals/forms/new-card",
        name: "modals-forms-new-card",
        component: () => import("@/views/modals/forms/NewCard.vue")
      },
      {
        path: "/crafted/modals/forms/new-address",
        name: "modals-forms-new-address",
        component: () => import("@/views/modals/forms/NewAddress.vue")
      },
      {
        path: "/crafted/modals/forms/create-api-key",
        name: "modals-forms-create-api-key",
        component: () => import("@/views/modals/forms/CreateApiKey.vue")
      },
      {
        path: "/crafted/modals/wizards/two-factor-auth",
        name: "modals-wizards-two-factor-auth",
        component: () => import("@/views/modals/wizards/TwoFactorAuth.vue")
      },
      {
        path: "/crafted/modals/wizards/create-app",
        name: "modals-wizards-create-app",
        component: () => import("@/views/modals/wizards/CreateApp.vue")
      },
      {
        path: "/crafted/modals/wizards/create-account",
        name: "modals-wizards-create-account",
        component: () => import("@/views/modals/wizards/CreateAccount.vue")
      },
      {
        path: "/crafted/widgets/lists",
        name: "widgets-list",
        component: () => import("@/views/widgets/Lists.vue")
      },
      {
        path: "/crafted/widgets/statistics",
        name: "widgets-statistics",
        component: () => import("@/views/widgets/Statistics.vue")
      },
      {
        path: "/crafted/widgets/charts",
        name: "widgets-charts",
        component: () => import("@/views/widgets/Charts.vue")
      },
      {
        path: "/crafted/widgets/mixed",
        name: "widgets-mixed",
        component: () => import("@/views/widgets/Mixed.vue")
      },
      {
        path: "/crafted/widgets/tables",
        name: "widgets-tables",
        component: () => import("@/views/widgets/Tables.vue")
      },
      {
        path: "/crafted/widgets/feeds",
        name: "widgets-feeds",
        component: () => import("@/views/widgets/Feeds.vue")
      },
      {
        path: "/documentation",
        name: "documentation",
        component: () => import("@/views/resources/Documentation.vue"),
        children: [
          {
            path: "build",
            name: "build",
            component: () =>
              import("@/views/resources/documentation/get-started/Build.vue")
          },
          {
            path: "setup-theme-skeleton",
            name: "setup-theme-skeleton",
            component: () =>
              import(
                "@/views/resources/documentation/get-started/SetupThemeSkeleton.vue"
              )
          },
          {
            path: "doc-overview",
            name: "doc-overview",
            component: () =>
              import("@/views/resources/documentation/get-started/Overview.vue")
          },
          {
            path: "updates",
            name: "updates",
            component: () =>
              import("@/views/resources/documentation/get-started/Updates.vue")
          },
          {
            path: "changelog",
            name: "changelog",
            component: () => import("@/views/resources/Changelog.vue")
          },
          {
            path: "utilities",
            name: "utilities",
            meta: {
              desc: "extended utility classes"
            },
            component: () =>
              import("@/views/resources/documentation/base/Utilities.vue")
          },
          {
            path: "helpers/flex-layouts",
            name: "flex-layouts",
            meta: {
              desc: "extended flex layout classes"
            },
            component: () =>
              import(
                "@/views/resources/documentation/base/helpers/FlexLayouts.vue"
              )
          },
          {
            path: "helpers/text",
            name: "text",
            meta: {
              desc: "extended text classes"
            },
            component: () =>
              import("@/views/resources/documentation/base/helpers/Text.vue")
          },
          {
            path: "helpers/background",
            name: "backkground",
            meta: {
              desc: "extended background classes"
            },
            component: () =>
              import(
                "@/views/resources/documentation/base/helpers/Background.vue"
              )
          },
          {
            path: "helpers/borders",
            name: "borders",
            meta: {
              desc: "extended borders classes"
            },
            component: () =>
              import("@/views/resources/documentation/base/helpers/Borders.vue")
          },
          {
            path: "forms",
            name: "forms",
            meta: {
              desc: "forms elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Forms.vue")
          },
          {
            path: "buttons",
            name: "buttons",
            meta: {
              desc: "buttons elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Buttons.vue")
          },
          {
            path: "indicator",
            name: "indicator",
            meta: {
              desc: "indicator element"
            },
            component: () =>
              import("@/views/resources/documentation/base/Indicator.vue")
          },
          {
            path: "rotate",
            name: "rotate",
            meta: {
              desc: "Rotate element"
            },
            component: () =>
              import("@/views/resources/documentation/base/Rotate.vue")
          },
          {
            path: "tables",
            name: "tables",
            meta: {
              desc: "extended bootstrap tables"
            },
            component: () =>
              import("@/views/resources/documentation/base/Tables.vue")
          },
          {
            path: "cards",
            name: "cards",
            meta: {
              desc: "card elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Cards.vue")
          },
          {
            path: "symbol",
            name: "symbol",
            meta: {
              desc: "symbol elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Symbol.vue")
          },
          {
            path: "badges",
            name: "badges",
            meta: {
              desc: "badge elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Badges.vue")
          },
          {
            path: "pulse",
            name: "pulse",
            meta: {
              desc: "pulse elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Pulse.vue")
          },
          {
            path: "bullets",
            name: "bullets",
            meta: {
              desc: "bullets elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Bullets.vue")
          },
          {
            path: "accordion",
            name: "accordion",
            meta: {
              desc: "accordion elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Accordion.vue")
          },
          {
            path: "carousel",
            name: "carousel",
            meta: {
              desc: "carousel elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Carousel.vue")
          },
          {
            path: "overlay",
            name: "overlay",
            meta: {
              desc: "overlay elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Overlay.vue")
          },
          {
            path: "separator",
            name: "separator",
            meta: {
              desc: "separator elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Separator.vue")
          },
          {
            path: "tabs",
            name: "tabs",
            meta: {
              desc: "tabs elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Tabs.vue")
          },
          {
            path: "breadcrumb",
            name: "breadcrumb",
            meta: {
              desc: "breadcrumb elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Breadcrumb.vue")
          },
          {
            path: "modal",
            name: "modal",
            meta: {
              desc: "modal elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Modal.vue")
          },
          {
            path: "pagination",
            name: "pagination",
            meta: {
              desc: "pagination elements"
            },
            component: () =>
              import("@/views/resources/documentation/base/Pagination.vue")
          },
          {
            path: "vue-select",
            name: "vue-select",
            meta: {
              desc: "Vue multiselect"
            },
            component: () =>
              import("@/views/resources/documentation/forms/VueSelect.vue")
          },
          {
            path: "vee-validate",
            name: "vee-validate",
            meta: {
              desc: "Vee validate"
            },
            component: () =>
              import("@/views/resources/documentation/forms/VeeValidate.vue")
          },
          {
            path: "element-ui",
            name: "element-ui",
            component: () =>
              import(
                "@/views/resources/documentation/element-ui/ElementUI.vue"
              ),
            children: [
              {
                path: "basic/layout",
                name: "layout",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/basic/Layout.vue"
                  )
              },
              {
                path: "basic/layout-container",
                name: "layout-container",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/basic/LayoutContainer.vue"
                  )
              },
              {
                path: "basic/icon",
                name: "icon",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/basic/Icon.vue"
                  )
              },
              {
                path: "basic/button",
                name: "button",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/basic/Button.vue"
                  )
              },
              {
                path: "basic/link",
                name: "link",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/basic/Link.vue"
                  )
              },
              {
                path: "basic/space",
                name: "space",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/basic/Space.vue"
                  )
              },
              {
                path: "form/radio",
                name: "radio",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Radio.vue"
                  )
              },
              {
                path: "form/checkbox",
                name: "checkbox",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Checkbox.vue"
                  )
              },
              {
                path: "form/input",
                name: "input",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Input.vue"
                  )
              },
              {
                path: "form/input-number",
                name: "input-number",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/InputNumber.vue"
                  )
              },
              {
                path: "form/select",
                name: "select",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Select.vue"
                  )
              },
              {
                path: "form/cascader",
                name: "cascader",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Cascader.vue"
                  )
              },
              {
                path: "form/switch",
                name: "switch",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Switch.vue"
                  )
              },
              {
                path: "form/slider",
                name: "slider",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Slider.vue"
                  )
              },
              {
                path: "form/time-picker",
                name: "time-picker",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/TimePicker.vue"
                  )
              },
              {
                path: "form/time-select",
                name: "time-select",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/TimeSelect.vue"
                  )
              },
              {
                path: "form/date-picker",
                name: "date-picker",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/DatePicker.vue"
                  )
              },
              {
                path: "form/date-time-picker",
                name: "date-time-picker",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/DateTimePicker.vue"
                  )
              },
              {
                path: "form/upload",
                name: "upload",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Upload.vue"
                  )
              },
              {
                path: "form/rate",
                name: "rate",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Rate.vue"
                  )
              },
              {
                path: "form/color-picker",
                name: "color-picker",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/ColorPicker.vue"
                  )
              },
              {
                path: "form/transfer",
                name: "transfer",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Transfer.vue"
                  )
              },
              {
                path: "form/form",
                name: "form",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/form/Form.vue"
                  )
              },
              {
                path: "data/table",
                name: "table",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/data/Table.vue"
                  )
              },
              {
                path: "data/tag",
                name: "tag",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/data/Tag.vue"
                  )
              },
              {
                path: "data/progress",
                name: "progress",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/data/Progress.vue"
                  )
              },
              {
                path: "data/tree",
                name: "tree",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/data/Tree.vue"
                  )
              },
              {
                path: "data/pagination",
                name: "data-pagination",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/data/Pagination.vue"
                  )
              },
              {
                path: "data/badge",
                name: "badge",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/data/Badge.vue"
                  )
              },
              {
                path: "data/skeleton",
                name: "skeleton",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/data/Skeleton.vue"
                  )
              },
              {
                path: "data/empty",
                name: "empty",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/data/Empty.vue"
                  )
              },
              {
                path: "notice/alert",
                name: "alert",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/notice/Alert.vue"
                  )
              },
              {
                path: "notice/loading",
                name: "loading",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/notice/Loading.vue"
                  )
              },
              {
                path: "notice/message",
                name: "message",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/notice/Message.vue"
                  )
              },
              {
                path: "notice/message-box",
                name: "message-box",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/notice/MessageBox.vue"
                  )
              },
              {
                path: "notice/notification",
                name: "notification",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/notice/Notification.vue"
                  )
              },
              {
                path: "navigation/affix",
                name: "affix",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/navigation/Affix.vue"
                  )
              },
              {
                path: "navigation/nav-menu",
                name: "nav-menu",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/navigation/NavMenu.vue"
                  )
              },
              {
                path: "navigation/tabs",
                name: "navigation-tabs",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/navigation/Tabs.vue"
                  )
              },
              {
                path: "navigation/breadcrumb",
                name: "navigation-breadcrumb",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/navigation/Breadcrumb.vue"
                  )
              },
              {
                path: "navigation/page-header",
                name: "page-header",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/navigation/PageHeader.vue"
                  )
              },
              {
                path: "navigation/dropdown",
                name: "dropdown",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/navigation/Dropdown.vue"
                  )
              },
              {
                path: "navigation/steps",
                name: "steps",
                component: () =>
                  import(
                    "@/views/resources/documentation/element-ui/navigation/Steps.vue"
                  )
              }
            ]
          },
          {
            path: "icons/duotone",
            name: "duotone",
            meta: {
              desc: "duotone svg icons"
            },
            component: () =>
              import("@/views/resources/documentation/general/Duotone.vue")
          },
          {
            path: "icons/bootstrap-icons",
            name: "bootstrap-icons",
            meta: {
              desc: "free, high quality, open source icon library"
            },
            component: () =>
              import(
                "@/views/resources/documentation/general/BootstrapIcons.vue"
              )
          },
          {
            path: "icons/font-awesome",
            name: "font-awesome",
            meta: {
              desc: "awesome font icons"
            },
            component: () =>
              import("@/views/resources/documentation/general/FontAwesome.vue")
          },
          {
            path: "icons/line-awesome",
            name: "line-awesome",
            meta: {
              desc: "line font icons"
            },
            component: () =>
              import("@/views/resources/documentation/general/LineAwesome.vue")
          }
        ]
      }
    ]
  },
  {
    path: "/sign-in",
    name: "sign-in",
    component: () => import("@/views/auth/SignIn.vue")
  },
  {
    path: "/sites/:id/edit",
    name: "site-editor",
    meta: { loginRequired: true },
    beforeEnter() {
      const { isSitesBuilderPreviewUser } = require("@/utils/sitesBuilderPreview");
      if (!isSitesBuilderPreviewUser()) {
        return { path: "/dashboard/reminderspage" };
      }
    },
    component: () => import("@/views/sites/SiteEditor.vue")
  },
  {
    path: "/sites/:id/preview",
    name: "site-preview",
    meta: { loginRequired: true },
    beforeEnter() {
      const { isSitesBuilderPreviewUser } = require("@/utils/sitesBuilderPreview");
      if (!isSitesBuilderPreviewUser()) {
        return { path: "/dashboard/reminderspage" };
      }
    },
    component: () => import("@/views/sites/SitePreview.vue")
  },
  {
    path: "/sign-in-ec",
    name: "sign-in-ec",
    component: () => import("@/views/auth/SignInEc.vue")
  },
  {
    path: "/sign-in-ed",
    name: "sign-in-ed",
    component: () => import("@/views/auth/SignInEd.vue")
  },  
  {
    path: "/sign-in-bibo",
    name: "sign-in-bibo",
    component: () => import("@/views/auth/SignInBibo.vue")
  }, 
  {
    path: "/sign-in-iglow",
    name: "sign-in-iglow",
    component: () => import("@/views/auth/SignInIGlow.vue")
  }, 
  {
    path: "/sign-in-ecc",
    name: "sign-in-ecc",
    component: () => import("@/views/auth/SignInECC.vue")
  }, 
  {
    path: "/sign-in-pcp",
    name: "sign-in-pcp",
    component: () => import("@/views/auth/SignInPCP.vue")
  }, 
  {
    path: "/openec",
    name: "openec",
    component: () => import("@/views/auth/OpenEc.vue")
  },
  {
    path: "/vantest",
    name: "vantest",
    component: () => import("@/views/VANTESTING.vue")
  },
  {
    path: "/s_d",
    name: "s_d",
    component: () => import("@/views/auth/SignIn.vue")
  },
  {
    path: "/policy",
    name: "companypolicymain",
    meta: { loginRequired: true },
    component: () => import("@/views/CompanyPolicyMain.vue")
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/auth/Logout.vue")
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: () => import("@/views/auth/SignUp.vue")
  },
  {
    path: "/password-reset",
    name: "password-reset",
    component: () => import("@/views/auth/PasswordReset.vue")
  },
  {
    path: "/aggpayment-capture",
    name: "aggpayment-capture",
    component: () => import("@/views/ghl/AggPaymentCapture.vue")
  },
  {
    path: "/pay",
    name: "agg-product-pay",
    component: () => import("@/views/ghl/AggProductPay.vue")
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/error/Error404.vue")
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/error/Error500.vue")
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404"
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 }
  }
});

router.beforeEach(() => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

router.beforeEach(AuthGuard); 


export default router;
